export default __webpack_public_path__ + "static/media/IF_MyStrengths_FullProfile_Desc_07.1bc2f84d.jpg";